import { render, staticRenderFns } from "./SpecialistSupervision.vue?vue&type=template&id=590b9ed9&scoped=true"
import script from "./SpecialistSupervision.vue?vue&type=script&lang=js"
export * from "./SpecialistSupervision.vue?vue&type=script&lang=js"
import style0 from "./SpecialistSupervision.vue?vue&type=style&index=0&id=590b9ed9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590b9ed9",
  null
  
)

export default component.exports